module.exports = __webpack_public_path__ + "static/media/photo-4-sm.f3fd0126.jpeg";